import axios from 'axios'
import { getAuthAxios } from '@artprov/design-system'
// import CookieManager from '../config/cookieManager'
import { useContratoStore } from '../common/store/contrato.store'

export const unAuthenticatedAxios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

let _authenticatedAxios = null

/**
 * Espera a que el registro global de AxiosProvider esté inicializado.
 *
 * Los useEffect de las páginas se ejecutan antes que el del provider padre
 * (AxiosProvider), por lo que getAuthAxios('default') puede lanzar
 * "Servicio no encontrado" en el primer render. Se reintenta hasta que el
 * registro esté disponible.
 */
async function waitForAuthAxios() {
  const maxAttempts = 50
  let lastError = null

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      return getAuthAxios('default')
    } catch (error) {
      lastError = error
      await new Promise((resolve) => setTimeout(resolve, 100))
    }
  }

  throw lastError
}

async function getAuth() {
  if (!_authenticatedAxios) {
    _authenticatedAxios = await waitForAuthAxios()
    _authenticatedAxios.interceptors.request.use((config) => {
      const contratoStore = useContratoStore.getState()
      if (contratoStore.contratoId) {
        config.headers['X-Contrato'] = contratoStore.contratoId
      }
      return config
    })
  }
  return _authenticatedAxios
}

// export const getUsuario = () => getAuthAxios('default').get('/v2/usuario/me')

// export const authenticatedAxios = {
//   get: async (...args) => (await getAuth()).get(...args),
//   post: async (...args) => (await getAuth()).post(...args),
//   put: async (...args) => (await getAuth()).put(...args),
//   delete: async (...args) => (await getAuth()).delete(...args),
//   patch: async (...args) => (await getAuth()).patch(...args),
//   interceptors: {
//     request: {
//       use: async (onFulfilled, onRejected) => (await getAuth()).interceptors.request.use(onFulfilled, onRejected),
//     },
//     response: {
//       use: async (onFulfilled, onRejected) => (await getAuth()).interceptors.response.use(onFulfilled, onRejected),
//     },
//   },
// }

// function init() {
//   const httpInstance = axios.create({
//     baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3006/v1',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   })

//   httpInstance.interceptors.request.use((config) => {
//     const token = CookieManager.get('authToken')
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`
//     }

//     // Always get the current contratoId from store for each request
//     const contratoStore = useContratoStore.getState()
//     if (contratoStore.contratoId) {
//       config.headers['X-Contrato'] = contratoStore.contratoId
//     }

//     return config
//   })

//   return httpInstance
// }

// const httpInstance = init()
// export { httpInstance }
// import axios from 'axios'
// import { getAuthAxios } from '@artprov/design-system'

// // console.log('🚀 ~ import.meta.env.VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL)
// export const unAuthenticatedAxios = axios.create({
//   baseURL: import.meta.env.VITE_API_BASE_URL,
// })

/**
 * Ruta pública – NO requiere token
 */
export const getDiasLaboralesPublic = (desde, dias) =>
  unAuthenticatedAxios.get('/v1/dias-laborales', {
    params: { desde, dias },
  })

/**
 * Ruta privada – CON token (normal)
 */
export const getDiasLaboralesPrivate = (desde, dias) =>
  getAuthAxios('default').get('/v2/dias-laborales', {
    params: { desde, dias },
  })
/**
 * Obtiene los datos del usuario autenticado.
 * Ruta privada – CON token.
 * @returns {Promise<object>} Respuesta con los datos del usuario.
 */
export const getUsuarioMe = () => getAuthAxios('default').get('/v2/usuario/me')

/**
 * Ruta privada – SIN token (caso de error esperado)
 */
export const getDiasLaboralesPrivateNoToken = (desde, dias) =>
  unAuthenticatedAxios.get('/v2/dias-laborales', {
    params: { desde, dias },
  })

export const authenticatedAxios = {
  get: async (...args) => (await getAuth()).get(...args),
  post: async (...args) => (await getAuth()).post(...args),
  put: async (...args) => (await getAuth()).put(...args),
  delete: async (...args) => (await getAuth()).delete(...args),
  patch: async (...args) => (await getAuth()).patch(...args),
  interceptors: {
    request: {
      use: async (onFulfilled, onRejected) => (await getAuth()).interceptors.request.use(onFulfilled, onRejected),
    },
    response: {
      use: async (onFulfilled, onRejected) => (await getAuth()).interceptors.response.use(onFulfilled, onRejected),
    },
  },
}
